<!-- <div class="content-container"> -->
<div class="container">
  <h1 class="font-lg mb-0">My invoices</h1>
  <div class="row mt-3">
    <div class="col-12">
      <table class="table table-responsive w-100 d-block d-md-table">
        <thead>
          <tr>
            <th>Auction</th>
            <th>Remittance #</th>
            <!-- <th>Bank details</th> -->
            <!-- <th>Premium %</th> -->
            <th>Sales</th>
            <th>less Adjustments</th>
            <th>less Premium $</th>
            <th>Balance to remit</th>
            <th class="text-center">Paid</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="!pagedResponse">
            <tr>
              <td class="text-center" colspan="7">
                <strong><i class="fa fa-spinner fa-spin"></i> Retrieving remittances...</strong>
              </td>
            </tr>
          </ng-container>
          <ng-container *ngIf="pagedResponse">
            <tr *ngIf="!pagedResponse.RemittanceSummaryItems.length">
              <td class="text-center" colspan="7">
                <strong>No remittances to list</strong>
              </td>
            </tr>
            <tr *ngFor="let item of pagedResponse.RemittanceSummaryItems">
              <td>{{item.Remittance.Auction?.Title}}</td>
              <td>
                <a [routerLink]="['detail',item.Remittance.Id]">{{item.Remittance.Id}}</a>
              </td>
              <td>
                <strong class="d-block">{{item.Remittance.Vendor.FirstName}} {{item.Remittance.Vendor.LastName}}</strong>
                <span class="d-block text-dark p-0 m-0">{{item.Remittance.Vendor.Email}}</span>
                <i class="d-block">Account #: {{item.Remittance.Vendor.AccountNumber}}</i>
              </td>
              <!-- <td>
                <div class="d-block">
                  <strong>Account Name: </strong><span>{{item.Remittance.Vendor.BankAccountName}}</span>
                </div>
                <div class="d-block">
                  <strong>BSB: </strong><span>{{item.Remittance.Vendor.BankAccountBsb}}</span>
                </div>
                <div class="d-block">
                  <strong>Account #: </strong><span>{{item.Remittance.Vendor.BankAccountNumber}}</span>
                </div>
              </td> -->
              <!-- <td>{{item.Remittance.VendorPremium|percent:'1.2-2'}}</td> -->
              <td>{{GetTotals(item,'sales')}}</td>
              <td>{{GetTotals(item,'adjustments')}}</td>
              <td>{{GetTotals(item,'premium')}}</td>
              <td>{{GetTotals(item,'net')}}</td>
              <td class="text-center">
                <i class="fa fa-times text-danger" *ngIf="!item.Remittance.Paid"></i>
                <i class="fa fa-check text-success" *ngIf="item.Remittance.Paid"></i>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>
<!-- </div> -->
